import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { ProgressBar } from 'primereact/progressbar'

import { EInvoiceError, useEInvoiceById } from '../../data'
import { EInvoiceWizard } from './e-invoice-wizard'
import { Title } from './title'

export const EInvoiceDetails: React.FC = () => {
  const location = useLocation()
  const errors = location.state?.errors as EInvoiceError
  const isFirstUpload = location.state?.isFirstUpload as boolean

  const { id } = useParams()

  // If id is "errors", don't try to fetch eInvoice data
  const isErrorsPage = id === 'errors'
  const { data: eInvoice, isLoading } = useEInvoiceById(
    isErrorsPage ? undefined : id,
  )

  const hasErrors = errors?.Results?.some(result => result.Level === 'Error')

  if (!isErrorsPage && isLoading)
    return <ProgressBar mode="indeterminate" style={{ height: '6px' }} />

  return (
    <>
      <Title
        showActions={!hasErrors && !isErrorsPage}
        isLoading={isLoading}
        isTrail={eInvoice?.Meta?.controlInformation.trialFlag}
      />
      <EInvoiceWizard
        eInvoice={isErrorsPage ? undefined : eInvoice}
        isLoading={isErrorsPage ? false : isLoading}
        errors={errors}
        isFirstUpload={isFirstUpload || isErrorsPage}
      />
    </>
  )
}
